import { UserService } from '../connections';

interface StartSignupResult {
  readonly success: boolean;
}

export function start(
  email: string,
  firstName: string,
  lastName: string,
  company: string | null,
  industry: string | null,
) {
  return UserService.post<StartSignupResult>(`signup/start`, {
    data: { email, firstName, lastName, company, industry },
  });
}

interface AccountVerificationResult {
  readonly verified: true;
  readonly message?: string;
}

export function verify(email: string, verificationCode: string) {
  return UserService.post<AccountVerificationResult>(`signup/verify`, {
    data: { email, verificationCode },
  });
}

export function finish(email: string, verificationCode: string, password: string) {
  return UserService.post<AccountVerificationResult>(`signup/finish`, {
    data: { email, verificationCode, password },
  });
}
